<template>
  <el-container class="myContainer">
    <el-aside width="350px" class="myContainer">
      <el-card class="box-card">
        <el-tree :data="helpCatalogData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false" class="myTree" draggable
                 :allow-drag="allowDrag"
                 :allow-drop="allowDrop"
                 @node-drop="handleDrop">

          <template #default="{ node, data }">
            <el-row style="width:100%" :gutter="1">
              <el-col :span="10" style="line-height: 32px">{{ node.label }}</el-col>

              <el-col :span="2.5" justify="end" v-show="currentHelpCatalogData.id === data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data" ></FrameButton>
              </el-col>
              <el-col :span="2.5" justify="end" v-show="currentHelpCatalogData.id === data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton :key="data.id" :button="editButton" :parentData="data" ></FrameButton>
              </el-col>
              <el-col :span="2.5" justify="end" v-show="currentHelpCatalogData.id === data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton v-if="!data.hasOwnProperty('children')" :key="data.id" :button="uploadButton" :parentData="data"></FrameButton>
              </el-col>
<!--              <el-col :span="2.5" justify="end" v-show="currentHelpCatalogData.id === data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton v-if="data.level === 0" :key="data.id" :button="impButton" ></FrameButton>
              </el-col>-->


            </el-row>
          </template>

        </el-tree>

      </el-card>
    </el-aside>

    <el-main class="myContainer">
      <div style="height: 100%;width: 100%;display: flex;flex-direction: row">
        <PdfView :url="currentUrl" style="width:100%;height: 100%"></PdfView>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {Refresh} from '@element-plus/icons-vue'
import PdfView from "@/views/applications/oa/PdfView.vue";
export default {
  name: "HelpCatalogConfig",
  components: {PdfView, Refresh},
  data() {
    return {
      addButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_catalog_add","title":"新增使用帮助目录","width":800,"height":600}
      },
      editButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_catalog_edit","title":"编辑目录","width":800,"height":600}
      },
      uploadButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-UploadFilled",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_content_upload","title":"上传PDF","width":800,"height":600}
      },
      impButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Grid",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_catalog_add","title":"导入目录","width":800,"height":600}
      },
      addData: {parentId: '', name: ''},
      helpCatalogData: [],
      currentHelpCatalogData: {},
      editData: {id: '', oldName: '', name: '',},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentUrl:''
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.loadHelpCatalogTree();
        },
        reloadFile: () => {
          console.log(this.currentHelpCatalogData.file_id);
          this.loadHelpCatalogTree();
          this.reloadCurrentHelpCatalog(this.currentHelpCatalogData.id);
        }
      }
    }
  },
  methods: {
    //--勾选--
    //操作方式
    nodeClickHandle(currentRow) {
      this.currentHelpCatalogData = currentRow;
      this.loadHelpCatalogFile(this.currentHelpCatalogData.file_id);
    },
    allowDrag(node){
      if(node.data.level === 0){
        return false;
      }
      return true;
    },
    allowDrop(draggingNode,dropNode,type){
      if(dropNode.data.parent_id === draggingNode.data.parent_id){
        return type !== 'inner'
      }else {
        return false;
      }
    },
    handleDrop(draggingNode,dropNode,dropType,ev){
      console.log('tree old:', draggingNode.id);
      console.log('tree target:', dropNode.id);
      console.log('tree old:', draggingNode.data.label, draggingNode.data.sort_no,dropType);
      console.log('tree target:', dropNode.data.label,draggingNode.data.sort_no, dropType);
      console.log(ev);
      draggingNode.data.targetId = dropNode.data.id;
      draggingNode.data.type = dropType;
      this.$http('helpCatalogService.updateSortNo', draggingNode.data, false).then(() => {
        this.loadHelpCatalogTree();
      }, errMsg => {
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      })
    },
    //获取目录
    async loadHelpCatalogTree() {
      this.helpCatalogData = await this.$http('helpCatalogService.getRootTree');
    },
    //获取文件目录
    async loadHelpCatalogFile(fileId) {
      if(fileId ===undefined){
        this.currentUrl = '';
        return;
      }
      let params = {fileId:fileId};
      this.currentFile = await this.$http('helpCatalogService.getHelpFile',params);
      console.log(this.currentFile.path_in_store);
      let path = this.currentFile.path_in_store.split('\\').join('/');
      let baseUrl = this.currentFile.baseUrl;
      //this.currentUrl = encodeURIComponent(this.currentFile.path_in_store);
      //this.currentUrl = encodeURIComponent('/filetest/框架手册.pdf');
      this.currentUrl = encodeURIComponent(baseUrl+'/'+path);
    },
    async reloadCurrentHelpCatalog(id) {
      let params = {id:id};
      this.currentHelpCatalogData = await this.$http('helpCatalogService.getCurrentCatalog',params);
      await this.loadHelpCatalogFile(this.currentHelpCatalogData.file_id);
    }
  },
  created() {
    this.loadHelpCatalogTree();
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
  height:100%;
}
.myTree {
  margin-left: -20px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

// 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

// 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }
}
</style>